import React from "react";
import packageImg from "../assets/images/packageImg.png";
import Button from "../components/form/Button";
import Header from "../components/Header";

const PackageDetail = () => {
  return (
    <div className="bg-accent-grey-50 h-full lg:w-[450px] w-full mx-auto">
      {/* <div className="flex items-center h-[56px]   rounded-bl-lg rounded-br-lg bg-black "></div>
      <div className="space-y-2.5 mt-[-23px] mx-4">
        <div className=" p-4 flex flex-col gap-3  border border-white bg-white  h-auto rounded-lg">
          <h3 className="text-black font-poppins font-bold text-base">Order</h3>
        </div>
      </div> */}
      <Header />

      <div className="container ">
        <div className="py-5">
          <div className="space-y-3">
            <div className="">
              <img
                src={packageImg}
                alt="order"
                className="w-full h-full object-contain rounded-lg"
              />
            </div>
            <div className="space-y-3">
              <h2 className="font-poppins uppercase font-semibold text-xl text-accent-onyx">
                OC-X Product
              </h2>
              <p className="font-poppins font-normal text-base text-accent-silver-900">
                Package - A
              </p>
              <h2 className="font-poppins uppercase font-semibold text-xl text-accent-onyx">
                Description
              </h2>
              <p className="font-poppins font-normal text-sm text-accent-silver-900 w-1/2">
                মুড়ি (৪০০ গ্রাম) ১ প্যাকেট চানাচুর - ৩০০ গ্রাম সরিষার তেল - ৪০০
                মিলি: ডাল ভাজা - ৫ প্যাকেট বিস্কুট - ২ প্যাকেট পটেটো চিপস (বড়)
                টোস্ট ড্রাই কেক কোকোনাট ওয়াটার
              </p>
              <Button
                children={"RM 35"}
                intent={"primary"}
                roundness={"round"}
                size={"lg"}
                classes={"w-full"}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageDetail;
